<template>
  <div class="card">
    <div class="card-header">
      <div class="list-header">
        <i class="list-type-icon ion" :class="content_type_icons[list.content_type]" :title="content_type_names[list.content_type]"></i>
        <i v-if="!list.public" class="fa fa-user-secret private-icon" title="This list is private. Only you can view and edit it."></i>
        <h3 class="list-title mb-1">
          <router-link :to="{name: 'listdetail', params: {id: list.id}}">{{ list.name }}</router-link>
        </h3>
        <div class="list-header-right">
          {{ list.items.length }} item{{ list.items | pluralize }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'

export default {
  name: 'ListLink',
  props: {
    list: Object,
  },
  data () {
    return {
      content_type_icons: constants.content_type_icons,
      content_type_names: constants.content_type_names
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 10px;
  .card-header {
    padding: 15px;
  }
}
.list-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .list-title {
    display: inline-block;
    margin: 0 auto;
  }
  .list-type-icon {
    color: #5b60c5;
    display: inline-block;
    font-size: 24px;
    line-height: 30px;
    padding: 0px 7px;
    float: left;
  }
  .private-icon {
    color: #5b60c5;
    display: inline-block;
    font-size: 18px;
    line-height: 20px;
    float: left;
  }
  .list-header-right {
    width: 65px;
    .edit-list-button:hover {
      color: #7276ce;
    }
  }
}
</style>

